module.exports = __webpack_public_path__ + "img/truck_10.1f5f350d.svg";